const initialState = {
    skuQuantity: 1,
    isSkuQuantityChanged: false,
    initialPageYOffset: 0,
    shouldShowQuantityPicker: false,
    isSkuInBasket: false,
    showUpdateMessage: false
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'SET':
            return { ...state, ...action.payload };
        case 'RESET_QTY':
            return { ...state, skuQuantity: 1, isSkuQuantityChanged: false };
        default:
            return state;
    }
};

export {
    initialState, reducer
};
